"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  kr: "th",
  한국어: "태국어",
  "받은 알림이 없습니다": "ไม่พบรายการแจ้งเตือน",
  알림: "แจ้งเตือน",
  설정: "ตั้งค่า",
  "모두 읽음": "ทำเครื่องหมายว่าอ่านหมดแล้ว",
  "읽은 알림 삭제": "ลบที่อ่านแล้วทั้งหมด",
  "모두 삭제": "ลบทั้้งหมด",
  "변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.": "การตั้้งค่าจะถูกบันทึกกลับเป็นค่าเริ่มต้นทั้งหมด\n\nระบบจะคืนค่าทั้งหมดเป็นเริ่มต้นเมื่อกดบันทึกการตั้งค่า",
  "알림 콘텐츠 설정": "เปิดการแจ้งเตือนคอนเทนต์",
  초기화: "กลับไปค่าตั้งต้น",
  저장: "บันทึก",
  "받은 알림이 없습니다.": "ไม่ได้รับการแจ้งเตือน",
  "설정이 저장되었습니다.": "บันทึกการตั้งค่าเรียบร้อยแล้ว",
  "설정 저장을 실패했습니다.": "ล้มเหลวในการบันทึก",
  "x 알림 x": "กรุณาไปที่",
  "알림 설정": "ตั้งค่าแล้วเลือกรับการแจ้งเตือน",
  "에서 받고 싶은 알림을 선택하세요.": "เพื่อรับข่าวสาร",
  "안내": "ประกาศ",
  "더보기": "ดูเพิ่มเติม",
  "<em onclick={{handleGoLogin}}>로그인</em>하시면<br />좋아하시는 BJ와 방송의<br />새로운 소식을 알려드립니다.": "หากท่านทำการ<em onClick={{handleGoLogin}}>เข้าสู่ระบบ</em> <br/>ท่านจะได้รับข่าวสารล่าสุดจาก<br /> BJ และช่องที่ท่านชื่นชอบ"
};